import { BrandsAction } from '@.pages';
import { BrandDetailPage } from '@/Components/Pages/Data/Brands/BrandDetailPage';
import { BrandsAllPage } from '@/Components/Pages/Data/Brands/BrandsAllPage/ui';

import { RoutePage } from '../types';

export const BrandsPage: RoutePage = {
    url: 'brands',
    component: <BrandsAllPage />,
    permissions: 'readOnly',
    sidebar: {
        name: 'Brands',
    },
    children: [
        {
            url: ':id',
            component: <BrandDetailPage />,
            children: [
                {
                    url: 'edit',
                    component: <BrandsAction edit />,
                    permissions: 'admin',
                },
            ],
        },
        {
            url: 'add',
            component: <BrandsAction />,
            permissions: 'admin',
        },
    ],
};
